import React, { useCallback, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import ProfileNameCard from 'components/ProfileNameCard';
import NoDataFound from 'components/NoDataFound'; // Assuming this component exists
import { GET_TRADERS_WITH_APPLIED_COUPONS } from 'pages/OfferCoupons/CouponGraphQL';

const CouponCountUsers = (props) => {
  const { count, usageCount, couponId, ...args } = props;
  const [userData, setUserData] = useState([]);

  const [fetchData, { loading, error }] = useLazyQuery(
    GET_TRADERS_WITH_APPLIED_COUPONS,
    {
      fetchPolicy: 'network-only',
    },
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleDropDown = useCallback((data) => {
    setUserData(data?.getTradersWithAppliedCoupons || []);
  }, []);

  const dropdownToggle = async () => {
    setDropdownOpen((prevState) => !prevState);

    if (!dropdownOpen) {
      try {
        const { data } = await fetchData({
          variables: {
            couponId,
          },
        });
        if (data) {
          handleDropDown(data);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const renderUserList = () => {
    if (loading) {
      return (
        <div className="text-center pb-1">
          <Loader />
        </div>
      );
    }

    if (error) {
      return (
        <div className="mx-3">
          <ErrorMessage error={error} />
        </div>
      );
    }

    if (userData.length === 0) {
      return (
        <div className="px-3 pb-2">
          <NoDataFound message="No data found!" />
        </div>
      );
    }

    return userData.map((item) => (
      <div
        key={item?.firstName}
        className="d-flex align-items-center mb-3 px-3 multicolor-profile-box"
      >
        <ProfileNameCard
          fname={item?.firstName.charAt(0)}
          lname={item?.lastName.charAt(0)}
        />
        <div className="ms-2 ps-1">
          <p className="f-14 text-dark-525 mb-1 fw-medium text-capitalize user-name text-nowrap overflow-hidden">
            {`${item?.firstName} ${item?.lastName}`}
          </p>
          <p className="f-12 mb-0 text-active fw-medium text-break">
            {item?.phone
              ? `${item?.callingCode?.callingCode}-${item?.phone}`
              : 'Not Available'}
          </p>
        </div>
      </div>
    ));
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={dropdownToggle} direction="down">
      <DropdownToggle
        className="bg-transparent border-0 text-dark f-14"
        disabled={!usageCount > 0}
        toggle={dropdownToggle}
      >
        {count}
      </DropdownToggle>
      <DropdownMenu className="cmn-dropdown coupon-user pt-3" {...args}>
        {renderUserList()}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CouponCountUsers;
